var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 6.87533C1.66602 6.15703 1.95136 5.46816 2.45927 4.96024C2.96718 4.45233 3.65605 4.16699 4.37435 4.16699H9.79102C10.1467 4.16699 10.4989 4.23705 10.8274 4.37315C11.156 4.50926 11.4546 4.70875 11.7061 4.96024C11.9576 5.21174 12.1571 5.5103 12.2932 5.83889C12.4293 6.16748 12.4993 6.51966 12.4993 6.87533V13.1253C12.4993 13.481 12.4293 13.8332 12.2932 14.1618C12.1571 14.4903 11.9576 14.7889 11.7061 15.0404C11.4546 15.2919 11.156 15.4914 10.8274 15.6275C10.4989 15.7636 10.1467 15.8337 9.79102 15.8337H4.37435C3.65605 15.8337 2.96718 15.5483 2.45927 15.0404C1.95136 14.5325 1.66602 13.8436 1.66602 13.1253V6.87533ZM16.0468 14.7403L13.3327 12.867V7.13533L16.0468 5.26116C17.0143 4.59283 18.3343 5.28616 18.3343 6.46116V13.5403C18.3343 14.7153 17.0143 15.4087 16.0468 14.7403Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic-camera.89b6d39a80588f93818e9483be8006be.svg";
export { ForwardRef as ReactComponent };